export default __webpack_public_path__ + "static/media/Camp-hub-Scroll.542bd5ea.png";